// extracted by mini-css-extract-plugin
export var entityChip = "_st-0";
export var entityChipMissing = "_st-1";